import { Unionize } from "fond/types";

/**
 * The views rendered in the modal. Only one view is active at any one time.
 */
export const ModalView = ["list", "staging", "upload"] as const;
export type ModalView = Unionize<typeof ModalView>;

export const AttachmentActionEventSource = ["list", "toolbar"] as const;
export type AttachmentActionEventSource = Unionize<typeof AttachmentActionEventSource>;

export const AttachmentEventLocation = ["panel", "modal"] as const;
export type AttachmentEventLocation = Unionize<typeof AttachmentEventLocation>;
